/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Approvals_SubtitleInputs */



/**
* | output |
* | --- |
* | "Runs waiting for your decision, across every agent." |
*
* @param {Agent_Approvals_SubtitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_approvals_subtitle = /** @type {((inputs?: Agent_Approvals_SubtitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Approvals_SubtitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Läufe, die auf Ihre Entscheidung warten – über alle Agenten hinweg.")
	return /** @type {LocalizedString} */ ("Runs waiting for your decision, across every agent.")
});